import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL + '/api';

export default function AuthCallback() {
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const code = params.get('code');
    
    const syncCalendar = async (token) => {
      try {
        await axios.post(
          `${API_URL}/calendar/sync`,
          {},
          { headers: { Authorization: `Bearer ${token}` } }
        );
        console.log("Calendar synced successfully");
      } catch (err) {
        console.warn("Calendar sync failed", err);
      }
    };

    if (code) {
      axios
        .get(`${API_URL}/auth/google/callback?code=${code}`)
        .then((response) => {
          localStorage.setItem('slotrescue_token', response.data.token);
          localStorage.setItem('slotrescue_user', JSON.stringify(response.data.user));
          toast.success('Successfully connected to Google!');
          syncCalendar(token);
          
          if (response.data.user.business_id) {
            navigate('/');
          } else {
            navigate('/business-setup');
          }
        })
        .catch((error) => {
          toast.error(error.response?.data?.detail || 'Authentication failed');
          navigate('/login');
        });
    } else {
      toast.error('No authorization code received');
      navigate('/login');
    }
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center space-y-4">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-teal-700 mx-auto"></div>
        <p className="text-gray-600">Connecting to Google Calendar...</p>
      </div>
    </div>
  );
}
